import {Button, Card, CardContent as MuiCardContent, FormControl, FormHelperText, Grid} from '@material-ui/core'
import {spacing} from '@material-ui/system'
import {Autocomplete, CircularProgressBar, SingleDropzone} from 'app/Components'
import {onKeyDown} from 'external-lib/utils/helpers'
import {Formik} from 'formik'
import {isLoading, isProcessing} from 'lib/progress'
import {Source} from 'lib/select'
import {State} from 'lib/store'
import {UploadFile} from 'lib/studentFiles'
import React from 'react'
import {connect, MapStateToProps} from 'react-redux'
import styled from 'styled-components'
import * as Yup from 'yup'

const CardContent = styled(MuiCardContent)(spacing)

type StateToProps = {
    readonly isLoading: boolean
    readonly isProcessing: boolean
}

type FormControlProps = {
    initialValues: UploadFile
    handleSubmit: (uploadFile: UploadFile) => void
}

const Schema = Yup.object().shape({
    type: Yup.string()
        .required('Pole jest wymagane'),
    file: Yup.string()
        .nullable(true)
        .required('Pole jest wymagane'),
})

class FormComponent extends React.Component<FormControlProps & StateToProps> {
    public render = () =>
        <>
            {
                this.props.isLoading
                    ? <CircularProgressBar/>
                    : <Formik
                        initialValues={this.props.initialValues}
                        validationSchema={Schema}
                        validateOnChange={false}
                        onSubmit={values => this.props.handleSubmit(values)}
                    >
                        {({
                              values,
                              errors,
                              touched,
                              handleChange,
                              handleBlur,
                              handleSubmit,
                              setFieldValue
                          }) => (
                            <form onSubmit={handleSubmit} onKeyDown={onKeyDown}>

                                <Card variant="outlined">
                                    <CardContent>
                                        <Grid container spacing={2}>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <FormControl margin="dense" fullWidth>
                                                    <SingleDropzone field={'file'} setFieldValue={setFieldValue} />
                                                    <FormHelperText error={Boolean(errors.file && touched.file)}>
                                                        {errors.file as string}
                                                    </FormHelperText>
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <FormControl margin="dense" fullWidth>
                                                    <Autocomplete
                                                        label={"Typ"}
                                                        field={'type'}
                                                        source={Source.STUDENT_FILE_TYPES}
                                                        value={values.type}
                                                        error={Boolean(errors.type && touched.type)}
                                                        setFieldValue={setFieldValue}
                                                        helperText={errors.type as string}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => handleSubmit()}
                                                    disabled={this.props.isProcessing}
                                                >
                                                    Wyślij
                                                </Button>
                                            </Grid>
                                        </Grid>

                                    </CardContent>
                                </Card>
                            </form>
                        )}
                    </Formik>
            }
        </>
}

const mapStateToProps: MapStateToProps<StateToProps, {}, State> = state => ({
    isLoading: isLoading(state),
    isProcessing: isProcessing(state),
})

export const Form = connect(mapStateToProps)(FormComponent)